// @ts-check

import moment from "moment";

export default function validDates(
  startDate,
  endDate,
) {
  const isValid = Boolean(startDate && endDate && startDate !== endDate &&
    moment(endDate).diff(startDate, "Days") < 30 &&
    (moment(startDate) >= moment().subtract(1, "days") &&
    moment().add(360, "days").diff(startDate, "Days") > 0) &&
    moment().add(360, "days").diff(endDate, "Days") > 0);

  return isValid;
}



// WEBPACK FOOTER //
// ./assets/shared/utils/validDates.js